<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>
        <span style="color:rgb(0,170,221)">Dashboard /</span> Incidents / Requests
      </p>
      <h2 class="mt-6">Incidents / Requests</h2>
      <div class="cell mt-10">
        <v-tabs>
            <v-tab>Emergencies</v-tab>
            <v-tab>DoctorApontments</v-tab>
            <v-tab>Healthcare Facilities Appointments</v-tab>

            <v-tab-item class="px-2">
                <Emergencies/>
            </v-tab-item>
            <v-tab-item>DoctorApontments</v-tab-item>
            <v-tab-item>IHealthcare Facilities Appointments</v-tab-item>
            
        </v-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Emergencies from '@/views/incidents/Emergencies.vue';
export default {
    components: {
        Emergencies
    }
}
</script>